// Détection « mobile » unifiée (même breakpoint que les @media : max-width 768px).
export function isMobileDevice() {
  try {
    return window.matchMedia('(max-width: 768px)').matches;
  } catch (_) {
    return (window.innerWidth || 1024) < 768;
  }
}
